import { SActionBtn, SFormAddOrEditDom, SLowcodeList, STableActions } from 'shj-components'
import { useCallback, useEffect, useRef, useState } from 'react'
import { cloneDeep, get } from 'lodash-es'
import { Empty, message, Skeleton, Switch, Tooltip } from 'antd'
import config from './config.ts'
import {
  delDealkingTalkOrderHomeConf,
  fetchDealkingTalkHasBusPower,
  fetchDealkingTalkOrderHomeConf,
  getRoleList,
  saveOrUpdateFirstMenu,
} from '@/services/talkOrder.ts'
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons'
import { getFileUrlPrefix } from '@/services/channelManagement.ts'
import AddOrEditFirstMenuDom from '@/pages/productContentConfig/talkOrderConfig/addOrEditDom'
import { useNavigate } from 'react-router-dom'
import { GetUserCompanys } from '@/services/index.ts'

const TalkOrderConfig = () => {
  const listRef = useRef<any>()
  const [companyList, setCompanyList] = useState<any>([])
  const [currentRecord, setCurrentRecord] = useState<any>()
  const [sortState, setSortState] = useState('')
  const sort = useRef<string>('')
  const [configs, setConfigs] = useState<any>(config)
  const [fileUrl, setFileUrl] = useState('')
  const [hasBusPower, setHasBusPower] = useState(false) //是否拥有业务权限
  const [loading, setLoading] = useState(true)
  const [roleList, setRoleList] = useState([])

  const navigate = useNavigate()

  // const microAppData = window.microApp.getData()

  const sortNumberClick = () => {
    const sortArr = ['', 'asc', 'desc']
    const index = sortArr.indexOf(sort.current)
    // console.log('index-----------',index)
    if (index === 2) {
      sort.current = ''
    } else {
      sort.current = sortArr[index + 1]
    }
    // console.log('sort.current-----------',sort.current)
    listRef.current.reset()
  }

  useEffect(() => {
    fetchDealkingTalkHasBusPower({}).then(res => {
      setHasBusPower(res)
      setLoading(false)
    })
    getCompanyListData()
    const newConfig = cloneDeep(config)
    newConfig.columns.forEach((item: any) => {
      if (item?.dataIndex === 'sortNumber') {
        item.title = (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
              justifyContent: 'space-between',
            }}
            onClick={sortNumberClick}
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>排序</div>
            <Tooltip
              title={!sortState ? '点击升序' : sortState === 'asc' ? '点击降序' : '取消排序'}
              placement={'top'}
            >
              <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '8px' }}>
                <CaretUpOutlined
                  style={{ fontSize: 12, color: sortState === 'asc' ? '#3D7EFF' : '#BFBFBF' }}
                />
                <CaretDownOutlined
                  style={{ fontSize: 12, color: sortState === 'desc' ? '#3D7EFF' : '#BFBFBF' }}
                />
              </div>
            </Tooltip>
          </div>
        )
      }
    })
    setConfigs(newConfig)
    getFileUrl()
    getRoles()
  }, [])

  const getFileUrl = () => {
    getFileUrlPrefix().then((res: any) => {
      // console.log('文件地址res-----------',res)
      setFileUrl(res)
    })
  }

  const fetchList = ({ current, pageSize, query }: any) => {
    // return new Promise(resolve => resolve({records: []}))
    query.pid = '0'
    if (sort.current) {
      query.orderBys = [
        {
          columnName: 'sortNumber',
          asc: sort.current === 'asc',
        },
      ]
    } else {
      query.orderBys = [
        {
          columnName: 'lastUpdatedTime',
          asc: false,
        },
      ]
    }
    return new Promise((resolve, reject) => {
      try {
        fetchDealkingTalkOrderHomeConf({ current, pageSize, data: query }).then((res: any) => {
          let records = get(res, 'list')
          const total = get(res, 'count')
          setSortState(sort.current)
          resolve({ records, total })
        })
      } catch (e) {
        sort.current = sortState
        reject({ success: false })
      }
    })
  }
  const getRoles = async () => {
    try {
      const res: any = await getRoleList({
        enabled: true,
      })
      console.log(res, '222222')

      const idList: any = []
      if (res?.length) {
        const roles: any = res
          .filter(item => item.id)
          .map(role => {
            return {
              value: role.id,
              label: role.name,
            }
          })
        // res.forEach((role: any) => {
        //   if (!idList.includes(role.code)) {
        //     roles.push({
        //       value: role.code,
        //       label: role.name,
        //     })
        //     idList.push(role.code); // 去下重，脏数据影响会产生问题
        //   }
        // });

        setRoleList(roles)
      }
    } catch (err) {
      console.error(err)
    }
  }
  const getStatusOptions = () => {
    return new Promise(async resolve => {
      const companyList = await getCompanyListData()
      resolve({
        companyList,
      })
    })
  }

  const getCompanyListData = () => {
    return GetUserCompanys().then((data: any[]) => {
      setCompanyList(data)
      return data
    })
  }

  const onDel = (record: any) => {
    if (record?.dtlNumber > 0) {
      return message.warning('请先清空下级数据再删除')
    }
    delDealkingTalkOrderHomeConf(record?.id).then((res: any) => {
      message.success('删除成功')
      listRef.current.reload()
    })
  }

  const onEdit = (record: any) => {
    setCurrentRecord(record)
  }

  const onAdd = useCallback(() => {
    setCurrentRecord({})
  }, [])

  const statusChange = (value: boolean, record: any) => {
    saveOrUpdateFirstMenu({ ...record, status: value }).then((res: any) => {
      message.success('操作成功')
      listRef.current.reload()
    })
  }

  const extension = {
    request: { fetchList, getStatusOptions },
    events: { onAdd },
    // auth,
    status: {
      btnDisabled: ({ selectedRowKeys }: any) => selectedRowKeys.length <= 0,
    },
    customRender: {
      roleList(text: any) {
        return text?.join('，')
      },
      companyListFn(text: any) {
        let str = ''
        text?.forEach((item: any, i: number) => {
          if (i !== text?.length - 1) {
            str += `${item?.busName},`
          } else str += item?.busName
        })
        return str
      },
      operationFn(text: any, record: any) {
        return (
          <STableActions>
            <SActionBtn onClick={() => onEdit(record)}>编辑</SActionBtn>
            <SActionBtn
              onClick={() => {
                navigate(`/config/talkOrderConfig/secondConfig/${record?.id}`)
              }}
            >
              菜单配置
            </SActionBtn>
            <SActionBtn confirm danger title="确定删除当前菜单?" onClick={() => onDel(record)}>
              删除
            </SActionBtn>
          </STableActions>
        )
      },
      statusFn(text: boolean, record: any) {
        return <Switch checked={text} onChange={value => statusChange(value, record)} />
      },
    },
  }

  return (
    <Skeleton loading={loading}>
      {hasBusPower ? (
        <SLowcodeList config={{ ...configs }} ref={listRef} {...extension} />
      ) : (
        <Empty description="暂无权限" style={{ paddingTop: '200px' }} />
      )}
      <SFormAddOrEditDom
        content={<AddOrEditFirstMenuDom />}
        open={!!currentRecord}
        onClose={() => {
          setCurrentRecord(null)
        }}
        fn={() => {
          listRef?.current?.reload?.()
          setCurrentRecord(null)
        }}
        record={currentRecord}
        fileUrl={fileUrl}
        companyList={companyList}
        roleList={roleList}
      />
    </Skeleton>
  )
}

export default TalkOrderConfig

// export default (props: any) => {
//   return (
//     <KeepAlive name={props?.location?.pathname}>
//       <TalkOrderConfig {...props} />
//     </KeepAlive>
//   );
// };
